import { getResponseToState } from "@mappers/getCartMapper";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { updateActivationDateRoute } from "@api-routes/eirSalesFacade";
import { IEirSalesUpdateActivationDatePayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesUpdateActivationDatePayload";
import { IEirSalesUpdateActivationDateResponse } from "@modules/eirSalesFacade/interfaces/responses/IEirSalesUpdateActivationDateResponse";

export const patchUpdateActivationDate = (
    prospectReference: string,
    offerId: number,
    payload: IEirSalesUpdateActivationDatePayload,
    options: IFetchOptions = {}
): Promise<IEirSalesUpdateActivationDateResponse | undefined> =>
    fetcher<IEirSalesUpdateActivationDateResponse>(updateActivationDateRoute(prospectReference, offerId), {
        method: "PATCH",
        body: payload,
        mapper: getResponseToState,
        ...options,
    });
